// test commit 
function encodeURL(object) {

    let parameters = [];

    for (let property in object) {
        if (object.hasOwnProperty(property)) {
            parameters.push(encodeURI(property + '=' + object[property]));
        }
    }
    return parameters.join('&')

}


function encodeURLNew(object) {

    let parameters = {};

    for (let property in object) {
        if (object.hasOwnProperty(property)) {

            if (Array.isArray(object[property])) {
                parameters[property] = object[property].join(',');
            } else {
                parameters[property] = object[property];
            }

            
        }
    }
    return parameters

}


export { encodeURLNew, encodeURL };
